<template>
  <div
    class="service__card"
    :class="{'service-selected': checked}"
    @click="onHandleService"
  >
    <div class="service__no-image"><i
        v-if="checked"
        class="fas fa-check text-red-500"
      ></i></div>
    <div class="service__info">
      <div class="service__name mb-1">{{ service.name }}</div>
      <div class="service__price font-bold"> {{ $t('main.price') }}: {{ $toCurrency(service.price) }}</div>
    </div>

  </div>
</template>
<script>
export default {
  name: "serviceCard",
  props: {
    service: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object,
      default: null,
    },
  },
  computed: {
    checked() {
      return (
        this.selected.services &&
        this.selected.services.find((s) => s.id == this.service.id)
      );
    },
  },
  methods: {
    onHandleService() {
      this.$store.dispatch(
        "clientOrder/updateElementService",
        {
          element_id: this.selected.element_id,
          service: this.service,
          remove: this.checked,
        },
        { root: true }
      );
    },
  },
};
</script>
<style scoped>
.service__card {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 1rem;
  cursor: pointer;
}
.service__card + .service__card {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #cfe2e8;
}
.service__image,
.service__no-image {
  border: 1px solid #bcbcbc;
}
.service__image {
  width: 190px;
  height: 75px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  text-align: right;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
}
.service__no-image {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service__card.service-selected .service__no-image,
.service__card.service-selected .service__image {
  border-color: #ff0000;
  border-width: 2px;
}
</style>
